// extracted by mini-css-extract-plugin
module.exports = {"three-dots-loader":"loading-indicator_three-dots-loader__1ieiS","grow":"loading-indicator_grow__1r28i","dark-loader":"loading-indicator_dark-loader__3IOJN"};